module.exports = __webpack_public_path__ + "img/blue_076.3a5e05c3.png";